
import { Vue, Component, Prop } from 'vue-property-decorator';
import ChartOptionsDropdown from '@/components/ChartOptionsDropdown.vue';

export interface ChartOptions {
	invoice: boolean;
	cash: boolean;
	credit: boolean;
	debit: boolean;
	includeTax: boolean;
	showValues: boolean;
}

/**
 * The KIM CHOK charts' per-chart options. Unlike the default charts these are
 * local widget state (not settingx), so they are v-model'd as one object: the
 * parent replaces the whole ChartOptions on change.
 *
 * The dropdown shell itself lives in the shared ChartOptionsDropdown.
 */
@Component({
	components: {
		ChartOptionsDropdown,
	},
})
export default class KimChokChartOptions extends Vue {
	@Prop({ required: true }) public readonly value!: ChartOptions;

	public docTypes: Array<{ key: keyof ChartOptions; text: string }> = [
		{ key: 'invoice', text: 'Sales Invoice' },
		{ key: 'cash', text: 'Cash Sales' },
		{ key: 'credit', text: 'Credit Note' },
		{ key: 'debit', text: 'Debit Note' },
	];

	public setOption(key: keyof ChartOptions, checked: boolean) {
		this.$emit('input', { ...this.value, [key]: checked });
	}
}
